import React from 'react';
import { Button } from './components/Button';
import { PurchasePopup } from './components/PurchasePopup';
import { TestimonialCard } from './components/TestimonialCard';
import { BonusCard } from './components/BonusCard';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/hNLLyw7iNTnm6wws377RKP/ChatGPT_Image_26_mar_2026,_12_38_55_p.m..png';
export function App() {
  const scrollToComprar = (e: React.MouseEvent<HTMLAnchorElement | HTMLImageElement>) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-[#0a0a0a] text-zinc-300 font-sans selection:bg-[#F59E0B] selection:text-black" data-id="element-0">
      <PurchasePopup data-id="element-1" />

      {/* HERO SECTION */}
      <header className="pt-16 pb-12 px-4 max-w-4xl mx-auto text-center" data-id="element-2">
        <h1 className="text-4xl md:text-6xl font-black text-white leading-tight mb-8 uppercase tracking-tight" data-id="element-3">
          <span className="text-red-500" data-id="element-4">⚠️</span> SI RESPONDES MENSAJES PERO NO
          ESTÁS VENDIENDO… <span className="text-[#F59E0B]" data-id="element-5">LEE ESTO</span>
        </h1>

        <div className="max-w-2xl mx-auto mb-10 cursor-pointer transition-transform hover:scale-105" onClick={scrollToComprar} data-id="element-6">
          <img src={PRODUCT_IMAGE} alt="El Sistema de Ventas Que Cierra" className="w-full h-auto drop-shadow-[0_0_30px_rgba(245,158,11,0.2)]" data-id="element-7" />
        </div>

        <Button href="#comprar" onClick={scrollToComprar} data-id="element-8">
          QUIERO EMPEZAR A CERRAR VENTAS
        </Button>
      </header>

      {/* SALES COPY */}
      <main className="max-w-3xl mx-auto px-4 py-12 text-lg md:text-xl leading-relaxed space-y-16" data-id="element-9">
        <section className="space-y-6" data-id="element-10">
          <p data-id="element-11">Todos los días pasa lo mismo.</p>
          <p data-id="element-12">
            Alguien te escribe: <strong data-id="element-13">“¿Precio?”</strong>
          </p>
          <p data-id="element-14">Respondes.</p>
          <p data-id="element-15">Y después…</p>
          <p className="text-2xl font-bold text-white" data-id="element-16">👉 Silencio.</p>
          <p data-id="element-17">Te dejan en visto. No vuelven a escribir. Desaparecen.</p>
          <p data-id="element-18">Y te quedas pensando:</p>
          <p className="italic text-zinc-400" data-id="element-19">
            “Tal vez es caro…” “Tal vez no le interesó…” “Tal vez después
            compra…”
          </p>
          <p className="font-bold text-white" data-id="element-20">Pero la verdad es otra.</p>
        </section>

        <section className="space-y-6 bg-zinc-900/50 p-8 rounded-2xl border border-zinc-800" data-id="element-21">
          <h2 className="text-3xl font-black text-white mb-6" data-id="element-22">
            💣 ESTÁS PERDIENDO VENTAS QUE YA ERAN TUYAS
          </h2>
          <p data-id="element-23">Sí.</p>
          <p data-id="element-24">Ese cliente que no respondió…</p>
          <p className="text-[#F59E0B] font-bold text-2xl" data-id="element-25">
            👉 Estaba mucho más cerca de comprar de lo que crees.
          </p>
          <p data-id="element-26">No era un curioso. No era alguien frío.</p>
          <p data-id="element-27">Era alguien interesado.</p>
          <p data-id="element-28">Pero algo pasó en la conversación…</p>
          <p data-id="element-29">Algo que lo hizo frenar.</p>
          <p data-id="element-30">Algo que lo hizo dudar.</p>
          <p data-id="element-31">Algo que lo hizo irse.</p>
        </section>

        <div className="text-center" data-id="element-32">
          <Button href="#comprar" onClick={scrollToComprar} data-id="element-33">
            QUIERO DEJAR DE PERDER VENTAS
          </Button>
        </div>

        <section className="space-y-6" data-id="element-34">
          <h2 className="text-3xl font-black text-white mb-6" data-id="element-35">
            😤 Y AQUÍ VIENE LA PARTE QUE NADIE TE DICE
          </h2>
          <p data-id="element-36">No es tu producto. No es el precio. No son tus seguidores.</p>
          <p className="text-[#F59E0B] font-bold text-2xl" data-id="element-37">
            👉 Es la forma en la que estás vendiendo.
          </p>
          <p data-id="element-38">Sí.</p>
          <p data-id="element-39">
            Aunque tengas un buen producto… Aunque tengas buenos precios… Aunque
            te escriban todos los días…
          </p>
          <p className="font-bold text-white text-xl" data-id="element-40">
            👉 Si no sabes cómo manejar la conversación… pierdes.
          </p>
        </section>

        <section className="space-y-6" data-id="element-41">
          <h2 className="text-3xl font-black text-white mb-6" data-id="element-42">
            🔥 HOY LAS VENTAS CAMBIARON
          </h2>
          <p data-id="element-43">
            Ya no gana el que más publica. No gana el que más seguidores tiene.
            No gana el que baja más el precio.
          </p>
          <p className="text-[#F59E0B] font-bold text-2xl" data-id="element-44">
            👉 Gana el que mejor responde.
          </p>
          <p data-id="element-45">Chats. Mensajes. Conversaciones.</p>
          <p data-id="element-46">Ese es el nuevo campo de juego.</p>
          <p data-id="element-47">Y si no sabes qué decir…</p>
          <p className="font-bold text-red-500 text-2xl" data-id="element-48">👉 Estás fuera.</p>
        </section>

        <section className="space-y-6 bg-zinc-900/50 p-8 rounded-2xl border border-zinc-800" data-id="element-49">
          <h2 className="text-3xl font-black text-white mb-6" data-id="element-50">
            🚫 PROBABLEMENTE YA INTENTASTE TODO
          </h2>
          <ul className="space-y-3 list-none pl-0" data-id="element-51">
            <li className="flex items-center gap-3" data-id="element-52">
              <span className="text-red-500" data-id="element-53">❌</span> Ver videos en YouTube
            </li>
            <li className="flex items-center gap-3" data-id="element-54">
              <span className="text-red-500" data-id="element-55">❌</span> Copiar lo que hacen otros
            </li>
            <li className="flex items-center gap-3" data-id="element-56">
              <span className="text-red-500" data-id="element-57">❌</span> Bajar precios
            </li>
            <li className="flex items-center gap-3" data-id="element-58">
              <span className="text-red-500" data-id="element-59">❌</span> Hacer promociones
            </li>
            <li className="flex items-center gap-3" data-id="element-60">
              <span className="text-red-500" data-id="element-61">❌</span> Publicar más seguido
            </li>
          </ul>
          <p className="mt-6" data-id="element-62">Y aun así…</p>
          <p data-id="element-63">Nada cambia.</p>
          <p className="font-bold text-white" data-id="element-64">
            Sigues teniendo consultas… Pero no ventas.
          </p>
        </section>

        <section className="space-y-4 bg-zinc-900/50 p-6 rounded-2xl border border-zinc-800" data-id="element-65">
          <h2 className="text-2xl font-black text-white" data-id="element-66">
            🧠 ¿POR QUÉ PASA ESTO?
          </h2>
          <p data-id="element-67">Porque nadie te enseñó lo más importante:</p>
          <p className="text-[#F59E0B] font-bold text-xl" data-id="element-68">
            👉 Qué decir en el momento exacto para cerrar una venta.
          </p>
          <p data-id="element-69">
            No es responder rápido. No es pasar el precio. No es mandar info.
          </p>
          <p className="font-bold text-white" data-id="element-70">
            👉 Es saber guiar la conversación. Qué decir, cómo y cuándo.
          </p>
        </section>

        <section className="space-y-6" data-id="element-71">
          <h2 className="text-3xl font-black text-white mb-6" data-id="element-72">
            🔑 EL VERDADERO PROBLEMA
          </h2>
          <p data-id="element-73">No es que no tengas clientes.</p>
          <p className="text-[#F59E0B] font-bold text-2xl" data-id="element-74">
            👉 Es que no estás sabiendo cerrar los que ya tienes.
          </p>
          <p data-id="element-75">Cada mensaje que recibes… Es una oportunidad.</p>
          <p data-id="element-76">Pero si no sabes manejarla…</p>
          <p className="font-bold text-red-500 text-xl" data-id="element-77">
            👉 Se convierte en una venta perdida.
          </p>
        </section>

        <div className="text-center" data-id="element-78">
          <Button href="#comprar" onClick={scrollToComprar} data-id="element-79">
            QUIERO APRENDER A CERRAR
          </Button>
        </div>

        <section className="space-y-8 text-center py-12" data-id="element-80">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-81">
            💥 POR ESO CREÉ:
          </h2>
          <h3 className="text-3xl md:text-4xl font-black text-[#F59E0B] mb-8" data-id="element-82">
            👉 EL SISTEMA DE VENTAS QUE CIERRA TODOS LOS DÍAS
          </h3>
          <p className="text-xl" data-id="element-83">Un método diseñado para algo simple:</p>
          <p className="text-2xl font-bold text-white" data-id="element-84">
            👉 Que dejes de perder ventas en el chat.
          </p>

          <div className="max-w-xl mx-auto mt-10 cursor-pointer transition-transform hover:scale-105" onClick={scrollToComprar} data-id="element-85">
            <img src={PRODUCT_IMAGE} alt="El Sistema de Ventas Que Cierra" className="w-full h-auto drop-shadow-[0_0_30px_rgba(245,158,11,0.2)]" data-id="element-86" />
          </div>
        </section>

        <section className="space-y-6 bg-zinc-900/50 p-8 rounded-2xl border border-zinc-800" data-id="element-87">
          <h2 className="text-3xl font-black text-white mb-6" data-id="element-88">
            🚀 ¿QUÉ ES EXACTAMENTE?
          </h2>
          <p data-id="element-89">
            Es un sistema práctico, directo y probado que te enseña paso a paso
            cómo convertir conversaciones en ventas.
          </p>
          <p data-id="element-90">Sin vueltas. Sin teoría innecesaria. Sin complicaciones.</p>
          <p className="font-bold text-white mb-6" data-id="element-91">Solo lo que funciona.</p>

          <ul className="space-y-4 list-none pl-0" data-id="element-92">
            <li className="flex items-start gap-3" data-id="element-93">
              <span className="text-2xl" data-id="element-94">✔️</span>
              <span data-id="element-95">
                Cómo responder cuando te dicen <strong data-id="element-96">“¿precio?”</strong>
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-97">
              <span className="text-2xl" data-id="element-98">✔️</span>
              <span data-id="element-99">Cómo mantener el interés del cliente</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-100">
              <span className="text-2xl" data-id="element-101">✔️</span>
              <span data-id="element-102">Cómo evitar que te dejen en visto</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-103">
              <span className="text-2xl" data-id="element-104">✔️</span>
              <span data-id="element-105">Cómo manejar objeciones sin perder la venta</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-106">
              <span className="text-2xl" data-id="element-107">✔️</span>
              <span data-id="element-108">Cómo cerrar sin presionar ni parecer desesperado</span>
            </li>
          </ul>
        </section>

        <section className="space-y-6" data-id="element-109">
          <h2 className="text-3xl font-black text-white mb-6" data-id="element-110">
            💬 ESTO NO ES TEORÍA
          </h2>
          <p data-id="element-111">Acá no vas a encontrar conceptos vacíos.</p>
          <p className="text-[#F59E0B] font-bold text-2xl" data-id="element-112">
            👉 Vas a encontrar:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6" data-id="element-113">
            <div className="bg-zinc-900 p-4 rounded-lg border border-zinc-800 text-center font-bold" data-id="element-114">
              Mensajes reales
            </div>
            <div className="bg-zinc-900 p-4 rounded-lg border border-zinc-800 text-center font-bold" data-id="element-115">
              Respuestas listas
            </div>
            <div className="bg-zinc-900 p-4 rounded-lg border border-zinc-800 text-center font-bold" data-id="element-116">
              Estructuras que funcionan
            </div>
            <div className="bg-zinc-900 p-4 rounded-lg border border-zinc-800 text-center font-bold" data-id="element-117">
              Situaciones del día a día
            </div>
          </div>
          <p className="font-bold text-white mt-6 text-xl text-center" data-id="element-118">
            Todo listo para copiar, adaptar y usar.
          </p>
        </section>

        <section className="space-y-6 text-center bg-[#F59E0B]/10 p-8 rounded-2xl border border-[#F59E0B]/30" data-id="element-119">
          <h2 className="text-3xl font-black text-white mb-6" data-id="element-120">
            🎯 ESO ES LO QUE CAMBIA TODO
          </h2>
          <p data-id="element-121">
            No necesitas más tráfico. No necesitas más seguidores. No necesitas
            gastar más en publicidad.
          </p>
          <p className="text-[#F59E0B] font-black text-3xl mt-6" data-id="element-122">
            👉 Necesitas cerrar mejor.
          </p>
        </section>
      </main>

      {/* BONUSES */}
      <section className="py-16 px-4 max-w-4xl mx-auto" data-id="element-123">
        <div className="text-center mb-12" data-id="element-124">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-125">
            🎁 ADEMÁS, INCLUYE BONUS EXCLUSIVO
          </h2>
          <p className="text-2xl font-black text-red-500 uppercase tracking-widest bg-red-500/10 inline-block px-6 py-2 rounded-full border border-red-500/30" data-id="element-126">
            GRATIS POR EL DÍA DE HOY
          </p>
          <p className="mt-6 text-xl" data-id="element-127">
            Para que empieces desde el primer día. Esto elimina la duda. Elimina
            la improvisación.{' '}
            <strong className="text-white" data-id="element-128">Te da claridad total.</strong>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-129">
          <BonusCard title="Mensajes listos para copiar y pegar" image={PRODUCT_IMAGE} data-id="element-130" />
          <BonusCard title="Respuestas para clientes indecisos" image={PRODUCT_IMAGE} data-id="element-131" />
          <BonusCard title="Seguimientos que convierten" image={PRODUCT_IMAGE} data-id="element-132" />
          <BonusCard title="Ejemplos reales de cierres" image={PRODUCT_IMAGE} data-id="element-133" />
        </div>
      </section>

      {/* PURCHASE SECTION */}
      <section id="comprar" className="py-16 px-4 bg-zinc-900 border-t border-zinc-800" data-id="element-134">
        <div className="max-w-3xl mx-auto space-y-12" data-id="element-135">
          <div className="bg-red-500/10 border border-red-500/30 p-8 rounded-2xl text-center" data-id="element-136">
            <h2 className="text-3xl font-black text-red-500 mb-6" data-id="element-137">
              ⚠️ IMPORTANTE
            </h2>
            <p className="text-xl mb-4" data-id="element-138">Esto no es magia. No es un truco.</p>
            <p className="text-2xl font-black text-white mb-6" data-id="element-139">
              👉 Es un sistema.
            </p>
            <p className="text-lg" data-id="element-140">
              Si lo aplicas →{' '}
              <strong className="text-green-400" data-id="element-141">funciona</strong>
            </p>
            <p className="text-lg mb-4" data-id="element-142">
              Si no lo aplicas →{' '}
              <strong className="text-red-400" data-id="element-143">nada cambia</strong>
            </p>
            <p className="text-zinc-400 italic" data-id="element-144">No hay punto medio.</p>
          </div>

          <div className="space-y-6 text-center" data-id="element-145">
            <h2 className="text-3xl font-black text-white" data-id="element-146">
              💣 PERO SI LO USAS CORRECTAMENTE…
            </h2>
            <p className="text-xl" data-id="element-147">
              Puedes empezar a cerrar más ventas desde hoy mismo.
            </p>
            <p className="text-2xl font-bold text-[#F59E0B]" data-id="element-148">Sí. Hoy.</p>
          </div>

          <div className="space-y-6 bg-black p-8 rounded-2xl border border-zinc-800" data-id="element-149">
            <h2 className="text-2xl font-black text-white mb-4" data-id="element-150">
              😤 LA REALIDAD ES ESTA
            </h2>
            <p data-id="element-151">Cada persona que te escribió y no compró…</p>
            <p className="font-bold text-white" data-id="element-152">👉 Era una oportunidad real.</p>
            <p data-id="element-153">Y probablemente la perdiste.</p>
            <p data-id="element-154">No porque no quería comprar…</p>
            <p className="text-[#F59E0B] font-bold" data-id="element-155">
              👉 Sino porque la conversación no lo llevó a hacerlo.
            </p>
            <p data-id="element-156">Esto pasa todos los días. Y sigue pasando ahora mismo.</p>
            <p data-id="element-157">Mientras lees esto… Hay alguien que podría comprarte…</p>
            <p className="font-bold text-red-500 text-xl" data-id="element-158">
              👉 Pero si no sabes qué decir… lo vas a perder.
            </p>
          </div>

          <div className="bg-black p-8 md:p-12 rounded-3xl border-2 border-[#F59E0B] text-center shadow-[0_0_50px_rgba(245,158,11,0.15)]" data-id="element-159">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-160">
              💸 TOMA ACCIÓN AHORA
            </h2>
            <p className="text-xl mb-8" data-id="element-161">
              Accede al sistema y empieza a convertir tus conversaciones en
              ingresos:
            </p>

            <h3 className="text-2xl md:text-3xl font-black text-[#F59E0B] mb-8" data-id="element-162">
              👉 EL SISTEMA DE VENTAS QUE CIERRA TODOS LOS DÍAS
            </h3>

            <div className="mb-10" data-id="element-163">
              <p className="text-zinc-500 text-2xl line-through font-bold mb-2" data-id="element-164">
                $49.990
              </p>
              <p className="text-6xl md:text-7xl font-black text-white" data-id="element-165">
                $19.990
              </p>
              <p className="text-zinc-400 mt-2" data-id="element-166">
                Pago único. Acceso inmediato.
              </p>
            </div>

            <Button href="https://checkout.importdigital.shop/cart/47617462501563:1" className="w-full md:w-auto text-2xl py-6 px-12 mb-8" data-id="element-167">
              ACCEDER AHORA
            </Button>

            <div className="space-y-3 text-left max-w-md mx-auto bg-zinc-900/50 p-6 rounded-xl" data-id="element-168">
              <p className="flex items-center gap-3" data-id="element-169">
                <span className="text-[#F59E0B]" data-id="element-170">🔥</span> No necesitas más
                seguidores
              </p>
              <p className="flex items-center gap-3" data-id="element-171">
                <span className="text-[#F59E0B]" data-id="element-172">🔥</span> No necesitas bajar
                precios
              </p>
              <p className="flex items-center gap-3" data-id="element-173">
                <span className="text-[#F59E0B]" data-id="element-174">🔥</span> No necesitas gastar
                más en publicidad
              </p>
              <div className="pt-4 mt-4 border-t border-zinc-800" data-id="element-175">
                <p className="font-black text-white text-xl text-center" data-id="element-176">
                  👉 Solo necesitas saber qué decir
                </p>
              </div>
            </div>

            <p className="mt-8 text-xl font-bold text-zinc-400" data-id="element-177">
              👉 La decisión es tuya.
            </p>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 bg-zinc-950 border-y border-zinc-900 px-4" data-id="element-178">
        <div className="max-w-5xl mx-auto" data-id="element-179">
          <h2 className="text-3xl md:text-4xl font-black text-center text-white mb-12" data-id="element-180">
            LO QUE DICEN QUIENES YA LO APLICAN
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-181">
            <TestimonialCard name="Martín G." age={32} city="Buenos Aires" quote="Antes me la pasaba respondiendo 'info' y nadie compraba. Apliqué la estructura del sistema y en la primera semana cerré 4 ventas que antes hubiera perdido. Es un viaje de ida, literal." data-id="element-182" />
            <TestimonialCard name="Sofía L." age={28} city="Córdoba" quote="Me daba mucha vergüenza pasar el precio porque sentía que los espantaba. Los scripts me salvaron la vida. Ahora sé exactamente qué decir para que el cliente sienta que lo estoy ayudando y no vendiendo." data-id="element-183" />
            <TestimonialCard name="Facundo R." age={35} city="Rosario" quote="Pensé que mi producto era caro y por eso me dejaban en visto. Mentira. Estaba vendiendo mal. Cambié la forma de responder los mensajes y mi tasa de cierre se duplicó. Tremendo." data-id="element-184" />
            <TestimonialCard name="Camila V." age={26} city="Mendoza" quote="Lo que más me sirvió fue la parte de seguimientos. Yo pensaba que era pesada si volvía a escribir, pero con estos mensajes logré reactivar conversaciones muertas y convertirlas en plata." data-id="element-185" />
            <TestimonialCard name="Joaquín M." age={41} city="Mar del Plata" quote="Directo al grano y sin humo. Te dice qué decir, cómo y cuándo. Si vendés por WhatsApp o Instagram, esto es obligatorio. Recuperé la inversión con la primera venta que cerré." data-id="element-186" />
          </div>
        </div>
      </section>

      <footer className="py-8 text-center text-zinc-600 text-sm border-t border-zinc-900" data-id="element-187">
        <p data-id="element-188">
          © {new Date().getFullYear()} El Sistema de Ventas Que Cierra. Todos
          los derechos reservados.
        </p>
      </footer>
    </div>;
}